import { render } from "./AggregationPicker.vue?vue&type=template&id=3a8ef26b"
import script from "./AggregationPicker.vue?vue&type=script&lang=js"
export * from "./AggregationPicker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DD6576\\tourbillon-timescale\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__